import React from 'react'
import { Row, Col } from 'react-bootstrap'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_ResponsiveInputList.scss'
import PropTypes from 'prop-types';

class ResponsiveInputsList extends React.Component {
  static propTypes = {
    list: PropTypes.array,
    renderFunction: PropTypes.func.isRequired,
    isListItemChecked: PropTypes.func,
    additionalOffset: PropTypes.number
  };

  constructor (props) {
    super(props)
    this.isChecked = this.isChecked.bind(this)
  }

  render () {
    const offset = Number.isInteger(this.props.additionalOffset) ? this.props.additionalOffset : 0
    const list = this.props.list
    const rows = []
    for (let i = 0; i < list?.length; i = i + 2) {
      rows.push(<Row key={i}>
        {list[i] && <Col className={styles['container']}
        xs={12} 
        sm={{span: 4 - offset, offset: 2 + offset}} 
        md={{span: 3 - offset, offset: 3 + offset}}
        lg={{span: 3 - offset, offset: 3 + offset}}>
          {this.props.renderFunction(list[i], this.isChecked(list[i]))}
        </Col>}
        {list[i + 1] && <Col
        className={styles['stacked-item']}
        xs={12}
        sm={{span: 4, offset: 0}}
        md={{span: 3, offset: 0}}
        lg={{span: 3, offset: 0}}>
          {this.props.renderFunction(list[i + 1], this.isChecked(list[i + 1]))}
        </Col>
        }

      </Row>)
    }

    return <div>
      {rows.map((row) => { return row })}
    </div>
  }

  isChecked (listItem) {
    if (!this.props.isListItemChecked) {
      return false
    }
    return this.props.isListItemChecked(listItem)
  }
}

export default (ResponsiveInputsList)
